import { GetDefaultIndexWithCollect } from "../../components";
import {
  useGetCompanyIdentitiesCommonInfoQuery,
  useCollectCompanyIdentitiesMutation,
} from "../../features/board/boardSlice";
import { useCompanyIdentityRoutes } from "./routes";
import { CompanyIdentityCollector } from "./companyIdentityCollector";

export { useCompanyIdentityRoutes };

export default GetDefaultIndexWithCollect({
  title: "شناسه شرکت ها",
  query: useGetCompanyIdentitiesCommonInfoQuery,
  collectMutation: useCollectCompanyIdentitiesMutation,
  collector: (collectCallback) => <CompanyIdentityCollector collectCallback={collectCallback} />
});
